import { useState } from "react"
import IProjectCreate from "rules/interface/project/create.interface"
import styles from "./index.module.scss"
import PhoneNumberStep from "./steps/phone-number"
import LocationStep from "./steps/location"
import ServiceTypeStep from "./steps/service-type"




const InstallmentForm = () => {

    const [step, setStep] = useState<number>(1)
    const [values, setValues] = useState<IProjectCreate>()


    const stepHandler = (currentStep) => {
        if (currentStep === 1) return <PhoneNumberStep
            next={() => setStep(prev => ++prev)}
            values={values}
            setValues={setValues}
        />
        else if (currentStep === 2) return <LocationStep
            next={() => setStep(prev => ++prev)}
            values={values}
            setValues={setValues}
        />
        else return <ServiceTypeStep
            values={values}
            setValues={setValues}
        />
    }



    return (
        <article className={styles.form}>
            <header className={styles.header__form}>
                <h2>درخواست خرید <span className="text-primary">اقساطی</span></h2>
            </header>

            <section className={styles.content__form}>
                {
                    stepHandler(step)
                }
            </section>
        </article>
    )
}

export default InstallmentForm